export enum MacrosUnits {
  GRAMS = "g",
  GRAMS_PER_KILO = "g/kg",
  PERCENTAGES = "%",
}
/** listof avaliable api methods */
export enum APIMethods {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum ScheduleViews {
  WEEK = 7,
  TWO_WEEKS = 14,
  FOUR_WEEKS = 28,
}

/** list of languages slugs in appliation */
export enum LanguagesSlugs {
  PL = "pl",
  EN = "en",
}

export enum Ownership {
  ALLOWEAT = "alloweat",
  OWN = "own",
}

export enum Status {
  ACTIVE = 0,
  HIDDEN = 1,
}
